<!-- Header Template Included - Starts -->
<app-header></app-header>
<!-- Header Templated Included - Ends -->
<ngx-spinner bdColor="rgba(51,51,51,0.8)" size="medium" color="#fff" loadingText="Loading..." type="ball-scale-multiple">
</ngx-spinner>

<section>
    <div class="dta_title mar-tb-20  pad-lr-15 col-md-12">{{'Purchase Orders' | translate}}
        <span style="float:right;font-size:16px;"><a href="#/poDashboard">{{'PO Dashboard' | translate}}&nbsp;<i class="fa fa-reply"
                    aria-hidden="true"></i></a>
        </span></div>
    <section class="part_search_bar" style="border-top:1px solid #dcdcdc;">
        <div class="row no-mar-lr">
            <div class="col-md-4 pad-top-30">
                <div class="row">
                    <div class="col-md-5 text-right pad-top-5">
                        {{'SUPPLIERCODE' | translate}} &nbsp;&nbsp;&nbsp;
                    </div>
                    <div class="col-md-5">
                        <ng-multiselect-dropdown *ngIf="suppCodeList" #suppliercodeTbl="ngModel" name="suppliercodetbl"
                        [(ngModel)]="suppCodeTbl" [settings]="dropdownSettings" [data]="suppCodeList" (onSelect)="onSupplierCodeSelect($event)"
                            (onDeSelect)="OnSupplierCodeDeSelect($event)" (onSelectAll)="onSupplierCodeSelectAll($event)"
                            (onDeSelectAll)="onSupplierCodeDeSelectAll($event)">
                        </ng-multiselect-dropdown>
                    </div>
                </div>
            </div>
            <div class="col-md-4 pad-top-30">
                <div class="row">
                    <div class="col-md-5 text-right pad-top-5">
                        {{'Location Code' | translate}} &nbsp;&nbsp;&nbsp;
                    </div>
                    <div class="col-md-5">
                        <ng-multiselect-dropdown *ngIf="locCodeList" #locationcodeTbl="ngModel" name="locationcodeTbl"
                        [(ngModel)]="locCodeTbl" [settings]="dropdownSettings" [data]="locCodeList">
                        </ng-multiselect-dropdown>
                    </div>
                </div>

            </div>
            <div class="col-md-2 pad-top-30">
                <button class="btn btn btn-dark" (click)="onChangeTable(config, $event)">{{'Display' | translate}}</button>
            </div>
            <div class="col-md-2  pad-top-30">
                <i class="fa fa-info-circle" aria-hidden="true" pTooltip="{{'Please choose Specification, atleast 1 Supplier code / Location to enable export' | translate}}"
                    tooltipPosition="top"></i>
                <button [disabled]="!enableExport" type="button" class="btn btn-dark" (click)="exportTable()">{{'Export'
                    | translate}}</button>
            </div>
        </div>
    </section>
    <!-- <div (click)="Download()">Download</div> -->
    <div class="row">
        <div class="col-md-2 pad-top-30 text-right">{{'Select Month Range' | translate}}</div>
        <div class="col-md-2 pad-top-30">
            <select [(ngModel)]="columnSize" name="Select Days" class="form-control" (ngModelChange)="getAllDates()">
                <option *ngFor="let n of columnFilterValue" [attr.value]="n">{{n}}</option>
            </select>
        </div>
        <div class="col-md-1 pad-top-30 text-right">{{'Spec' | translate}}.</div>
        <div class="col-md-2 pad-top-30">
            <select [(ngModel)]="name" name="Select name" class="form-control" (ngModelChange)="onChangeTable(config, $event)">
                <option *ngFor="let n of names" [attr.value]="n">{{n}}</option>
            </select>
        </div>

    </div>



    <div class="row no-mar-lr mar-btm-40">
        <div class="col-md-12">
            <!-- <pagination *ngIf="config.paging" class="pagination-sm pull-right pad-top-10" [(ngModel)]="page"
                [totalItems]="length" [itemsPerPage]="itemsPerPage" [maxSize]="maxSize" [boundaryLinks]="true" [rotate]="false"
                (pageChanged)="onChangeTable(config, $event)" (numPages)="numPages = $event">
            </pagination>
            <ng-table [config]="config" (tableChanged)="onChangeTable(config)" [rows]="rows" [columns]="columns"></ng-table> -->


         
            <pagination *ngIf="config.paging" class="pad-top-10" [(ngModel)]="page"
            [totalItems]="length" [itemsPerPage]="itemsPerPage" [maxSize]="maxSize" [boundaryLinks]="true" [rotate]="false"
            (pageChanged)="onChangeTable(config, $event)" (numPages)="numPages = $event">
            </pagination>
                <table class="table-fixed">
                    <thead>
                        <tr>
                            <th *ngFor="let col of columnsData;">{{ col.title }}</th>
                        </tr>
                    </thead>
                    <tbody *ngIf="poFixedData">
                        <tr *ngFor="let data of poFixedData">
                            <ng-container *ngFor="let col of columnsData;">
                                <td *ngIf="!col.name.includes('day') && !col.name.includes('spec')">{{ data[col.name] }}</td>
                                <td *ngIf="col.name.includes('day') || col.name.includes('spec')"><div [innerHTML]="data[col.name]"></div></td> 
                            </ng-container>          
                        </tr>
                    </tbody>
                </table>
              


            <div class="noRecords" *ngIf="rows.length == 0">{{'No records Found' | translate}}!</div>
        </div>
    </div>
</section>